import {useStream} from '@esgi/ui-kit/utils';
import React from 'react';
import {Observable} from 'rxjs';
import {Loader, LoaderProps} from './loader';

type Props = Omit<LoaderProps, 'show'> & { observable: Observable<boolean> };

export function ObservableLoader(props: Props): JSX.Element {
	const {observable, ...loaderProps} = props;
	const show = useStream(props.observable);
	return <Loader show={show} {...loaderProps}/>;
}
